






import Vue from "vue";
import { mapGetters } from "vuex";

import ErrorCard from "@/components/app/ErrorCard.vue";

export default Vue.extend({
  name: "ErrorDialog",
  components: {
    ErrorCard,
  },
  computed: {
    ...mapGetters(["lastError", "showErrorDialog"]),
  },
});
